export default ({$fetcher: fetchData}) => {
  return {
    namespaced: true,
    state: {
      featureFlags: {}
    },
    getters: {
      enableSecureWorkflow(state) {
        return state.featureFlags?.secure_translations_enabled;
      },
      enableSeriesCheckboxes(state) {
        return state.featureFlags?.series_checkboxes_enabled;
      },
      enablePoliceCertificates(state) {
        return state.featureFlags?.police_certificates_enabled;
      },
      enableFolkeregister(state) {
        return state.featureFlags?.folkeregister_enabled;
      },
      disableIdentityVerificationGeneral(state) {
        return state.featureFlags?.skip_identity_verification || false;
      },
      disableIdentityVerificationSupplier(state) {
        return state.featureFlags?.skip_identity_verification_for_suppliers || false;
      },
      disableIdentityVerificationBuyer(state) {
        return state.featureFlags?.skip_identity_verification_for_buyers || false;
      }
    },
    actions: {
      fetchFeatureFlags({commit}) {
        return new Promise((resolve, reject) => {
          fetchData.getFeatureFlags().then((data) => {
            commit('setFeatureFlags', data);
            resolve(data);
          })
          .catch((error) => {
            reject(error);
          });
        });
      },
    },
    mutations: {
      setFeatureFlags(state, value) {
        state.featureFlags = value;
      }
    }
  };
};
